// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1HQrC","dragIcon":"Choice_dragIcon__2tY8d","left":"Choice_left__8v2rg","input":"Choice_input__3JP4x"};